(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const menu = document.getElementById('menu');
  const hamburger = document.getElementById('hamburger');
  const hamburgerButton = hamburger.querySelector('button');
  const toggles = menu.querySelectorAll('.menu-toggle');

  function closeSubmenus() {
    toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.parentElement.classList.remove('expanded-menu');
    });
  }

  function setMobileMenu(open, moveFocus = true) {
    closeSubmenus();
    menu.classList.toggle('mobile-navigation', open);
    menu.classList.toggle('is-hidden-mobile', !open);
    hamburger.classList.toggle('is-hidden', open);
    hamburgerButton.setAttribute('aria-expanded', String(open));
    document.getElementById('announcement')?.classList.toggle('is-hidden', open);
    if (open) window.zE?.('messenger:set', 'zIndex', 10);
    if (moveFocus) (open ? menu.querySelector('.menuitem') : hamburgerButton).focus();
  }

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      closeSubmenus();
      toggle.setAttribute('aria-expanded', String(open));
      toggle.parentElement.classList.toggle('expanded-menu', open);
    });
  });

  menu.querySelectorAll('.menu-back').forEach((button) => {
    button.addEventListener('click', () => {
      closeSubmenus();
      button.closest('.submenu').parentElement.querySelector('.menu-toggle').focus();
    });
  });

  hamburgerButton.addEventListener('click', () => setMobileMenu(true));
  menu.querySelector('.hamburger__close').addEventListener('click', () => setMobileMenu(false));

  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) closeSubmenus();
  });

  menu.addEventListener('focusout', (event) => {
    if (event.relatedTarget && !menu.contains(event.relatedTarget) && menu.classList.contains('mobile-navigation')) {
      setMobileMenu(false, false);
      return;
    }
    const expanded = event.target.closest('.expanded-menu');
    if (expanded && !expanded.contains(event.relatedTarget)) closeSubmenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const expanded = menu.querySelector('.menu-toggle[aria-expanded="true"]');
    if (expanded) {
      closeSubmenus();
      expanded.focus();
      return;
    }
    if (menu.classList.contains('mobile-navigation')) setMobileMenu(false);
  });

  window.matchMedia('(min-width: 769px)').addEventListener('change', () => setMobileMenu(false, false));

  } catch(e) { console.error(e); }
})();
})();
